import routerOptions0 from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}